import { DividerCard, DividerCardBody, DividerCardTitle } from '@/components/atoms/DividerCard';
import { useLivescoreLayout } from '@/context/LivescoreLayoutContext';
import { convertAlpha, getCountryName } from '@/utils/countryCode';

const CompetitionRecord = ({
  id,
  name,
  countryCode,
  slug,
}: {
  id: string;
  name: string;
  countryCode?: string;
  slug?: string;
}) => {
  const isoCode = convertAlpha(countryCode ?? '')?.toLocaleLowerCase() ?? 'un';
  const countryName = isoCode !== 'un' ? getCountryName(isoCode) : 'Międzynarodowa';

  return (
    <a
      href={`/livescore/league/${slug ?? id}`}
      className="flex items-center gap-3 dark:bg-gray-650 bg-white_theme-50 rounded-lg px-4 py-3"
    >
      <div className="relative h-6 w-6 rounded-full overflow-hidden [mask-image:radial-gradient(white,black)] [-webkit-mask-image:-webkit-radial-gradient(white,black)]">
        <span className="flex items-center justify-center absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 h-[30px] aspect-[4/3] scale-[0.93]">
          <img
            src={`https://flagcdn.com/${isoCode}.svg`}
            alt={`${countryName} flaga`}
            width={40}
            height={30}
            className="h-[30px] w-[40px]"
          />
        </span>
      </div>
      <div>
        <p className="font-medium text-xxs text-gray-400 -mb-0.5">{countryName}</p>
        <p className="text-black dark:text-white font-bold text-[12px] mb-0 h-[16px] overflow-ellipsis line-clamp-1">
          {name}
        </p>
      </div>
    </a>
  );
};

const TopCompetitionsCard = () => {
  const { competitions } = useLivescoreLayout();

  return (
    <DividerCard>
      <DividerCardTitle>Topowe ligi</DividerCardTitle>
      <DividerCardBody>
        <ul className="list-none px-0 space-y-2">
          {competitions?.enabled.sort((a, b) => {
            const aCode = convertAlpha(a.category?.country_code ?? '')?.toLocaleLowerCase() ?? 'un';
            const aName = aCode ? getCountryName(aCode) : null;

            const bCode = convertAlpha(b.category?.country_code ?? '')?.toLocaleLowerCase() ?? 'un';
            const bName = bCode ? getCountryName(bCode) : null;

            if (aName === null && bName === null) return 0;
            if (aName === null) return 1;
            if (bName === null) return -1;

            return aName?.localeCompare(bName as string) ?? 0;
          }).map(({ id, name, category, slug }) => (
            <li key={id}>
              <CompetitionRecord id={id} name={name} countryCode={category?.country_code} slug={slug} />
            </li>
          ))}
        </ul>
      </DividerCardBody>
    </DividerCard>
  );
};

export default TopCompetitionsCard;
